import { PingResponse } from "@common/api/ping";

const CACHE_BUSTING_HEADERS = {
  "Cache-Control": "no-cache, no-store, must-revalidate, max-age=0",
  Pragma: "no-cache",
  Expires: "0",
} as const;

export interface PingApiArgs {
  appId: string;
  apiBaseUrl: string;
  userData: Record<string, any>;
  previewGuideId?: string;
  activeGuideId?: string;
  previewChecklistId?: string;
  activeChecklistId?: string;
  activeTourPlaybackVersion?: string;
  requestId: number;
}

export async function fetchPing({
  appId,
  apiBaseUrl,
  requestId,
  userData,
  previewGuideId,
  activeGuideId,
  activeChecklistId,
  previewChecklistId,
  activeTourPlaybackVersion,
}: PingApiArgs) {
  function encodeUserData(data: Record<string, any>) {
    const newData = { ...data };
    for (const [key, value] of Object.entries(newData)) {
      if (value === undefined) {
        newData[key] = "__unset__";
      }
    }
    return newData;
  }

  const payload = {
    app_id: appId,
    user_data: userData?.id ? encodeUserData(userData) : undefined,
    previewGuideId,
    activeGuideId,
    activeChecklistId,
    previewChecklistId,
    activeTourPlaybackVersion,
  };

  const res = await fetch(`${apiBaseUrl}/widget/ping`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Pyne-Request-Id": requestId.toString(),
      ...(previewGuideId ? CACHE_BUSTING_HEADERS : {}),
    },
    body: JSON.stringify(payload),
  });

  const data = (await res.json()) as PingResponse;
  const allGuides = data.allGuides;
  const allChecklists = data.allChecklists;
  const userState = data.userState as Record<string, any>;
  const debugData = data.debug as any | undefined;

  return { userState, allGuides, allChecklists, debugData };
}
